// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BackButton-button-0833{width:40px;height:100%}`, "",{"version":3,"sources":["webpack://./src/page/Header/BackButton.module.scss"],"names":[],"mappings":"AAAA,wBACE,UAAA,CACA,WAAA","sourcesContent":[".button {\n  width: 40px;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `BackButton-button-0833`
};
module.exports = ___CSS_LOADER_EXPORT___;
